import { SupportedLocale } from '../enums/supported-locale.enum';
export function normalizeSupportedLocale(raw) {
    if (!raw)
        return undefined;
    const lowered = raw.toLowerCase();
    return Object.values(SupportedLocale).find((locale) => locale.toLowerCase() === lowered);
}
